import { Button, Collapse, Modal, Panel, TextArea } from 'components-antd';
import { ICON_VARIANT_TYPE, Icons } from 'pages/Workshop/Forms/Icons';
import styles from './styles.module.scss';
import { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { CheckboxOptionType } from 'antd/es/checkbox';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

const CheckboxGroup = Checkbox.Group;

export const FormNotesModal = (props) => {
  const { isOpen, onClose, defaultNote, editNoteInfo, onSaveNote, signatories } = props;

  const signatoryOptions = useMemo(() => {
    return signatories.map((item) => ({ label: item.Name, value: item.signatoryId }));
  }, [signatories]);

  const [noteMessage, setNoteMessage] = useState(defaultNote);

  const [checkedList, setCheckedList] = useState<CheckboxOptionType[]>(signatoryOptions);
  const [checkAll, setCheckAll] = useState(true);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (!defaultNote && noteMessage) {
      setNoteMessage('');
    }
  }, [defaultNote]);

  const onChange = (list: CheckboxValueType[]) => {
    const updatedList = signatoryOptions.filter((signatory) => list.includes(signatory.value));
    setCheckedList(updatedList);
    setCheckAll(updatedList.length === signatoryOptions.length);
  };

  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    setCheckedList(e.target.checked ? signatoryOptions : []);
    setCheckAll(e.target.checked);
  };

  const onChangeSignature = () => {
    setIsActive(!isActive);
  };

  const onUpdateNote = (message) => {
    onSaveNote(message);
  };

  const renderTitle = () => {
    if (editNoteInfo) {
      return (
        <div className={styles.editNoteHeader}>
          {editNoteInfo.note ? 'Edit Note' : 'Add a Note'}
          <div className={styles.signerInformation}>
            To: <span className={styles.signerName}>{editNoteInfo.Name}</span>
          </div>
        </div>
      );
    }

    return defaultNote ? 'Edit Note' : 'Add a Note';
  };

  return (
    <Modal
      open={isOpen}
      width={675}
      footer={null}
      onCancel={onClose}
      maskClosable={false}
      destroyOnClose
      closeIcon={<Icons variant={'modal-close'} stroke="#262626" />}
      title={renderTitle()}
      className={classNames(styles.notesModal, { [styles.editNoteModal]: editNoteInfo })}
    >
      <div className={styles.noteMessageWrapper}>
        <TextArea
          rows={4}
          maxLength={250}
          className={styles.textArea}
          placeholder="Enter note..."
          onChange={(e) => setNoteMessage(e.target.value)}
          value={noteMessage}
        />
      </div>

      {signatoryOptions.length > 0 && (
        <div className={styles.noteRecipientsWrapper}>
          <div className={styles.noteRecipientLabel}>Send To</div>

          <Collapse
            onChange={onChangeSignature}
            expandIconPosition={'end'}
            ghost={true}
            activeKey={isActive ? 'signatories' : ''}
            key="signatories"
            expandIcon={({ isActive }) =>
              isActive ? (
                <Icons className={styles.collapsibleIcon} variant={ICON_VARIANT_TYPE.ARROW_UP} />
              ) : (
                <Icons className={styles.collapsibleIcon} variant={ICON_VARIANT_TYPE.ARROW_DOWN} />
              )
            }
          >
            <Panel
              header={
                <Checkbox
                  onChange={onCheckAllChange}
                  checked={checkAll}
                  className={styles.collapseHeaderCheckbox}
                  disabled={true}
                >
                  Everyone{' '}
                  <span className={styles.signatoriesCount}>({signatoryOptions.length})</span>
                </Checkbox>
              }
              key="signatories"
              className={styles.noteSignatoriesPanel}
            >
              <CheckboxGroup
                options={signatoryOptions}
                value={checkedList?.map((list) => list.value)}
                onChange={onChange}
                className={checkAll ? styles.allCheckedGroup : ''}
                disabled={true}
              />
            </Panel>
          </Collapse>
        </div>
      )}

      <div
        className={classNames(styles.buttonWrapper, {
          [styles.deleteButtonWrapper]: !editNoteInfo && defaultNote,
        })}
      >
        {!editNoteInfo && defaultNote && (
          <div className={styles.deleteNoteText} onClick={() => onUpdateNote('')}>
            <Icons variant={ICON_VARIANT_TYPE.DELETE_TRASH} />
            Delete Note
          </div>
        )}

        <Button
          variant="secondary"
          onClick={() => onUpdateNote(noteMessage)}
          disabled={!noteMessage}
          className={classNames(styles.noteSaveButton, {
            [styles.disabledNoteButton]: !noteMessage,
          })}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
